const EIGHT =
  "M27.79 21.45A12.5 12.5 0 1 1 46.21 21.45A14 14 0 1 1 27.79 21.45Z M41.5 13a4.5 4.5 0 1 0-9 0a4.5 4.5 0 1 0 9 0Z M43 32a6 6 0 1 0-12 0a6 6 0 1 0 12 0Z";

export const LogoMark = ({ className = "", stroke = 2, withText = true, title = "1818 Brands" }) => (
  <svg viewBox="0 0 66 99" className={className} role="img" aria-label={title}>
    <g fill="currentColor">
      <rect x="3" y="1" width="10" height="45" rx="1.5" />
      <path fillRule="evenodd" d={EIGHT} />
    </g>
    <g transform="translate(0 52)" fill="none" stroke="currentColor" strokeWidth={stroke}>
      <rect x="3" y="1" width="10" height="45" rx="1.5" />
      <path d={EIGHT} />
    </g>
    {withText && (
      <text
        transform="translate(59 1.5) rotate(90)"
        fontFamily="Inter, Helvetica, sans-serif"
        fontSize="5.9"
        letterSpacing="0.4"
        fill="currentColor"
      >
        EIGHTEENEIGHTEENBRANDS
      </text>
    )}
  </svg>
);
